var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.41 0 0 2.41 150.45 355.15)",
    id: "uCXrycX2Ta6vPrPWQo8Vc"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(62,137,229)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -50.82163 58.56094 L -50.82163 58.56094 L -50.82163 58.56094 C -49.35778 47.582100000000004 -45.51616 37.05484 -39.56476 27.713610000000003 L -37.87037 25.054120000000005 L -11.377190000000002 -5.327949999999994 L -4.669860000000003 -11.766989999999995 L -4.669860000000003 -11.766989999999995 C 0.058949999999997615 -16.306649999999994 3.722089999999997 -21.838579999999993 6.055699999999997 -27.964299999999994 L 6.967389999999997 -30.357499999999995 L 6.967389999999997 -30.357499999999995 C 9.906009999999997 -38.07137999999999 11.663259999999998 -46.18467999999999 12.179739999999997 -54.42317 L 12.426679999999998 -58.362069999999996 L 12.426679999999998 -58.362069999999996 C 12.431929999999998 -58.445769999999996 12.485989999999997 -58.51853 12.564619999999998 -58.5477 C 12.643249999999998 -58.57687 12.731679999999997 -58.556979999999996 12.790249999999999 -58.49695 L 50.47345 -19.87522 L 50.47345 -19.87522 C 50.79211 -19.54862 50.90279 -19.071949999999998 50.76064 -18.63835 C 50.61849 -18.20475 50.247080000000004 -17.886129999999998 49.796910000000004 -17.81158 L 37.67542 -15.80433 L 37.67542 -15.80433 C 29.2053 -14.401720000000001 21.271480000000004 -10.736699999999999 14.712640000000004 -5.196670000000001 L 14.288540000000005 -4.838440000000001 L 14.288540000000005 -4.838440000000001 C 13.357440000000004 -4.051970000000001 12.516590000000004 -3.164490000000001 11.781480000000006 -2.192330000000001 L 0.2894600000000054 13.005389999999998 L -18.248539999999995 38.37318 L -18.248539999999995 38.37318 C -19.958839999999995 40.713589999999996 -21.919449999999994 42.86034 -24.095569999999995 44.77532 L -24.095569999999995 44.77532 L -24.095569999999995 44.77532 C -31.080879999999993 50.92239 -39.37138999999999 55.40224 -48.34124 57.876689999999996 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3 1.3 -1.67 1.67 343.66 128.08)",
    id: "IR_PTTAdBzDhXrRM0BN6m"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(152,192,160)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(229,215,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -46.633 -30.29052 C -46.81195 -31.45355 -46.359190000000005 -32.62191 -45.38317 -33.51579 C -44.40714 -34.409670000000006 -42.99576 -34.948550000000004 -41.48702 -35.00338 L 1.2759299999999953 -36.55744 L 42.59273999999999 -35.52533 L 42.59273999999999 -35.52533 C 43.72097999999999 -35.49715 44.787479999999995 -35.11913 45.55326999999999 -34.475989999999996 C 46.31905999999999 -33.83284999999999 46.72011999999999 -32.978339999999996 46.66658999999999 -32.103939999999994 L 42.775479999999995 31.45201000000001 L 42.775479999999995 31.45201000000001 C 42.6005 34.309990000000006 39.561539999999994 36.55742000000001 35.871959999999994 36.55742000000001 L -31.87076000000001 36.55742000000001 L -31.87076000000001 36.55742000000001 C -34.42466000000001 36.55742000000001 -36.57533000000001 35.07678000000001 -36.877910000000014 33.11023000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.23 0.77 -0.77 -2.23 68.47 449.1)",
    id: "uE2RE6hQfTs2JxlnB7P1Y"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(6,64,88)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.6
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -5.20446 C 2.87286 -5.20446 5.20446 -2.87286 5.20446 0 C 5.20446 2.87286 2.87286 5.20446 0 5.20446 C -2.87286 5.20446 -5.20446 2.87286 -5.20446 0 C -5.20446 -2.87286 -2.87286 -5.20446 0 -5.20446 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(38.3 38.3 -3.27 3.27 399.79 72.47)",
    id: "zFVVoPKr1go8VFWtgdyMI"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(21,245,193)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(68,67,65)",
      fillRule: "nonzero",
      opacity: 0.34
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -1.4607 -0.63658 C -1.29546 -1.08357 -1.00438 -1.084 -0.6542500000000001 -1.21404 C -0.45306000000000013 -1.28876 -0.2286700000000001 -1.5799400000000001 -0.006910000000000083 -1.5799400000000001 C 0.3272699999999999 -1.5799400000000001 0.6680099999999999 -1.3821800000000002 0.9311299999999999 -1.2960500000000001 C 1.14892 -1.22476 1.3065699999999998 -1.29119 1.42563 -1.06129 C 1.53812 -0.84408 1.5730199999999999 -0.26134 1.5730199999999999 0 C 1.5730199999999999 0.87212 0.8652099999999998 1.57993 -0.006910000000000194 1.57993 C -0.8790300000000002 1.57993 -1.57302 1.55275 -1.57302 0.68062 C -1.57302 0.41619 -1.57392 -0.3303100000000001 -1.4607 -0.6365799999999999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.38 0 0 2.38 288.6 78.13)",
    id: "i-p_pvRvSOVN_oigjD3TF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.39 0 0 2.39 291.18 80.6)",
    id: "ODPSmyXxoxSN3xTwaO9_u"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.36 0 0 2.36 293.27 82.62)",
    id: "JkDncPeBoo-eB1Hy1Xv8L"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.35 0 0 2.35 294.34 84.32)",
    id: "5pvQ-ZfxqzIL_-MHU5rQW"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.36 0 0 2.36 295.56 86.09)",
    id: "dXA06f2JDzk1ZzUSqOAx-"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.33 0 0 2.33 297.52 87.25)",
    id: "yYY3f2wT3gToq0C-8iZqf"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.34 0 0 2.34 300.74 90.85)",
    id: "9ylvwm_J-EjyHN577NN3s"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.35 0 0 2.35 302.4 92.13)",
    id: "bnm4P0YwTr6DrkF7BOcka"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.35 0 0 2.35 304.39 94.28)",
    id: "Bj_fHjQqtqxcJbYTFQSjS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 306.24 96.6)",
    id: "tKX9VXcSAH86XtSDYQCvt"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 309.14 98.29)",
    id: "a6pdRngFfDGFD1xwZ1qrL"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.34 0 0 2.34 309.84 100)",
    id: "3NrOacV1M-inmYz5vtBTw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.33 0 0 2.33 298.62 89.24)",
    id: "yTuxI1Sozsg7vC14pxVv5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.36 0 0 2.36 312.13 101.58)",
    id: "_GI7fpJrdSH4NSsQ78hIi"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.36 0 0 2.36 314.67 104.01)",
    id: "d6baxiJfp5mbJJ7nEuLLa"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.33 0 0 2.33 316.75 106.02)",
    id: "m-chVGrMFWOVsG-HXCEui"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 317.8 107.7)",
    id: "lTaKTRNm9sB6LeXVMIu5h"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.33 0 0 2.33 318.99 109.45)",
    id: "86DDpMkdaVXeNHprMTBAO"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 320.93 110.59)",
    id: "Kz8MPU-eNVblupaFdi59R"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 324.13 114.14)",
    id: "ZKTcP8OsjmlVQ7KZ5RdqD"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 325.76 115.43)",
    id: "T8P4Gfok5BrllTEVT9Iek"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 327.73 117.53)",
    id: "Ce62VWsqKZFkTEFdZ2RR9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.29 0 0 2.29 329.55 119.84)",
    id: "Ud8SRLiJRt0p9ovM81873"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.29 0 0 2.29 332.42 121.5)",
    id: "2zlcsJiSNEemjD070-4Sx"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 333.12 123.2)",
    id: "_DNFSDNKh7m95Ef778Ax2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 322.03 112.55)",
    id: "hdaz9BOgCWZPv9cK50H0z"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3 0 0 2.3 334.87 126.07)",
    id: "TmtLsRe3rJ9W2bwgV8qnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.31 0 0 2.31 337.56 128.32)",
    id: "mbDh7KuucnS29bCHKD-bt"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.34 0 0 2.34 340.65 128.98)",
    id: "mkr1c8CjYDPXn2u5ixsrN"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 341.72 130.66)",
    id: "v458Ws6ySqXbeTOmqsdSv"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.34 0 0 2.34 342.9 132.41)",
    id: "HttPbqvOfkALpWKkluY1u"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 344.83 133.57)",
    id: "u9q-ynV3w-0NkoDmvCpHu"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 348.05 137.11)",
    id: "0bQMTshDdZTCcUIJ2Qdn2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 349.68 138.39)",
    id: "P25pz-KPVJfHinvLWWGcJ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 351.64 140.49)",
    id: "H5wFuTCFIo5w9Izs2qFDh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.29 0 0 2.29 353.46 142.8)",
    id: "oy24iWgRNrzUq8uRWaA04"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.29 0 0 2.29 356.34 144.46)",
    id: "n-IXEYoKOrBnzldp0I-ZQ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 357.03 146.16)",
    id: "IjO2_ZAyYTjf4pU1cQ14n"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 345.94 135.53)",
    id: "zGlMNDBTJbKZp0izS_rKd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 359.45 147.65)",
    id: "6GyD43XdHOmpVtR_W-5Rl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32 0 0 2.32 361.96 150.05)",
    id: "tn0LvDdTwUA_2GV71gg1R"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3 0 0 2.3 363.98 152.02)",
    id: "eATXDpmtHQ5bPdIPLrYen"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 365.03 153.67)",
    id: "hBltc-Tf5cGm83MwFbGmK"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3 0 0 2.3 366.19 155.39)",
    id: "RYVmj3zpVXR7_cUkz3dBh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 368.09 156.53)",
    id: "ej9_GTrJXqX_Q5D3H_FVw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 371.25 160.02)",
    id: "88Xdw8N-1VfYWYawevqWi"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 372.86 161.27)",
    id: "0YJg6BU3ex18_oc3Glt8X"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 375.42 163.52)",
    id: "yAO1gDhYD1hI6Oryz82zG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.53605 26.12632 L 20.53605 -26.12632",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.25 0 0 2.25 378.48 166.2)",
    id: "ZhKv_U5EjrmMJSOKOyXX-"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -21.1023 25.94764 L 21.102310000000003 -25.947650000000003",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.25 0 0 2.25 381.45 168.46)",
    id: "10xTaYCF6xkUQXrlVGW05"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -21.15864 25.66642 L 21.15864 -25.666430000000002",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 382.88 170.58)",
    id: "Q0Gxble-IN-qfDLGrbSXF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -21.48402 25.47507 L 21.484029999999997 -25.475080000000002",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.28 0 0 2.28 369.19 158.46)",
    id: "N7rTbz5kY1Nj_MIje_-XJ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -20.25723 26.20579 L 20.257240000000003 -26.20579",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.14 0 0 -2.14 395.57 182.42)",
    id: "k2MoHvQ2JBjkjnQR65ilx"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -25.24235 25.36935 L 25.242340000000002 -25.36935",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.14 0 0 -2.14 399.77 185.18)",
    id: "7R4R6L7TOg3nHPN0B-ggF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -26.21256 24.6337 L 26.21256 -24.633709999999997",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.14 0 0 -2.14 397.44 183.71)",
    id: "ti7ZojQWRKAvJQR45C4LF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -25.83115 24.76628 L 25.831159999999997 -24.766270000000002",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.14 0 0 -2.14 393.34 180.44)",
    id: "Hb53fBANSc2_gBwssqO61"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -24.76381 25.38408 L 24.763800000000003 -25.38408",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.27 0 0 -2.27 388.83 175.67)",
    id: "JuvEMtN1N2gUXDsIhSLh4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -22.12026 24.64994 L 22.12026 -24.64994",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.12 0 0 -2.12 385.83 173)",
    id: "13KZvB49jjGLrHgwDOPXo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -23.32008 27.15432 L 23.320089999999997 -27.154310000000002",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.14 0 0 -2.14 387.91 174.17)",
    id: "YID7w0DgTihcMqCPPN2es"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -23.06972 26.4419 L 23.06972 -26.4419",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.14 0 0 -2.14 391.68 177.47)",
    id: "cPRUsrMBIyqHQ25qVgrLw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(182,181,181)",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -24.09577 25.33558 L 24.09577 -25.335569999999997",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.89 1.89 -1.36 1.36 257.92 224.94)",
    id: "bnAtaSl3-rq-9ups4ZyRS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,98,136)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(62,137,229)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -26.65789 -22.36257 C -26.7064 -23.06069 -26.54518 -23.755650000000003 -26.2123 -24.283330000000003 C -25.87942 -24.811010000000003 -25.40438 -25.124640000000003 -24.89938 -25.150150000000004 L 23.005879999999998 -27.569720000000004 L 23.005879999999998 -27.569720000000004 C 23.79218 -27.609430000000003 24.556959999999997 -27.208630000000003 25.128099999999996 -26.457520000000002 C 25.699239999999996 -25.70641 26.028769999999998 -24.668080000000003 26.042509999999996 -23.576220000000003 L 26.666189999999997 25.958019999999994 L 26.666189999999997 25.958019999999994 C 26.671619999999997 26.389109999999995 26.550409999999996 26.804709999999993 26.330449999999995 27.109179999999995 C 26.110489999999995 27.413649999999993 25.810729999999996 27.580769999999994 25.500129999999995 27.572089999999996 L -21.276470000000007 26.264729999999997 L -21.276470000000007 26.264729999999997 C -22.420280000000005 26.232759999999995 -23.365540000000006 25.016949999999998 -23.475360000000006 23.436459999999997 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eac51be68e9d44b92db15bf7a9b834ca.svg";
export { ForwardRef as ReactComponent };